import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export const stripeTableRef = 'stripe-payment-methods-list';
export default grapesjs.plugins.add('stripe-payment-methods-list', (editor, opts = {}) => {
  const default_types = {
    stripeList: stripeTableRef,
  };
  const default_labels = {
    stripeList: 'Stripe Payment Methods List',
  };
  const options = {
    ...{
      pfx: 'stripe-list',
      labels: default_labels,
      types: default_types,
      labelShoppingCartCategory: 'Payment Gateway',
      blocks: [stripeTableRef],
    },
    ...opts,
  };

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
